import { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ActionHeader } from '..';
import { makeSTPTransaction } from '../../../../redux-store/actions/commercialTransactions';
import en from '../../../../lang/en-us';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import { onResendLoginOTP as resendOtp } from '../../../../redux-store/actions/login';
import OtpSentTextWrapper from '../../../../lib/OtpSentTextWrapper';
import {
    verifyChangeEmailOTP as verifyOTP,
    sendPhoneOTP,
} from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { maskEmail, maskMobileNumber } from '../../../../utils/utilityFunctions';
import { OTP_ACTIONS } from '../../../../utils/constants';
import { CommercialRootPath } from '../routeConfig';
import { STPPaths } from './types';

const { dashboard, dbCommercial } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function STPOtp(props: any) {
    const { apiPayload } = props.location.state || {};
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otpRef, reqId }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const dispatch = useDispatch();

    const { mobile } = useSelector(({ authReducer }: RootStateType) => ({ ...authReducer }));

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                action: OTP_ACTIONS.stp,
                reqId,
            };
            const otpRes = await props.verifyOTP(payload);
            let res = await props.makeSTPTransaction({
                ...apiPayload,
                reqId: otpRes.body.reqId,
            });
            props.history.replace(`${CommercialRootPath}${STPPaths.success}`, {
                reqId: res.body.reqId,
            });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const onResend = async () => {
        try {
            let { body = {} } = await props.resendOtp({
                otpRef: otpRef || '',
                reqId: reqId || '',
                action: OTP_ACTIONS.stp,
            });
            setOtpInfo({
                otp: null,
                reqId: body.reqId,
                otpRef: body.otpRef,
            });
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.stp.heading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <OtpSentTextWrapper
                            mobile={maskMobileNumber(props.mobile)}
                            email={maskEmail(props.email)}
                            userRegisteredWith={props.userRegisteredWith}
                        />
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        verifyOTP,
        makeSTPTransaction,
        sendPhoneOTP,
        resendOtp,
    },
)(STPOtp);
